import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import { APP_ENV, BUGSNAG_API_KEY } from './config'

const getAppType = () => {
  if (typeof window === 'undefined') {
    return 'server'
  }
  return 'browser'
}

// 多重実行しても動作に影響はないがコンソールが警告で埋まるので抑制する
declare global {
  // eslint-disable-next-line no-var
  var __bugsnagInitialized: boolean
}

if (!globalThis.__bugsnagInitialized) {
  globalThis.__bugsnagInitialized = true

  Bugsnag.start({
    appType: getAppType(),
    releaseStage: APP_ENV,
    enabledReleaseStages: ['production', 'staging'],
    apiKey: BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
      // 無視するエラーメッセージのリスト
      const ignoredMessages = [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        'The user aborted a request',
        'Request aborted',
        'Failed to load chunk',
        'Invariant: attempted to hard navigate to the same URL',
        // Firebase Authの二重ログインエラー
        'INTERNAL ASSERTION FAILED',
      ]

      // 無視するエラータイプのリスト
      const ignoredErrorTypes = ['AbortError', 'TimeoutError']

      // エラーメッセージのチェック
      const shouldIgnoreByMessage = event.errors.some((error) =>
        ignoredMessages.some((message) => error.errorMessage.includes(message)),
      )

      // エラータイプのチェック
      const shouldIgnoreByType = event.errors.some((error) => ignoredErrorTypes.includes(error.errorClass))

      if (shouldIgnoreByMessage || shouldIgnoreByType) {
        console.debug('[Bugsnag] Ignoring error:', {
          message: event.errors[0]?.errorMessage,
          type: event.errors[0]?.errorClass,
          reason: shouldIgnoreByMessage ? 'matched ignored message' : 'matched ignored type',
        })
        return false
      }

      event.addMetadata('SourceVersion', {
        buildDateTime: process.env.NEXT_PUBLIC_BUILD_DATE_TIME,
      })
    },
  })
}
export default Bugsnag
